<template>
  <v-container>
    <v-form ref="form" v-model="valid" lazy-validation>
      <div class="titles blue-text">Announcement</div>
      <v-card class="pb-4 rounded-5 shadow-0">
        <v-btn
          small
          @click="gotoMail"
          absolute
          top
          right
          style="top: -50px; margin-right: -1%"
        >
          <v-icon small>mdi-backburger</v-icon>Back
        </v-btn>
        <v-card-text class="pb-0">
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <label for="">{{ type == "sms*" ? "Title*" : "Subject*" }}</label>
              <v-text-field
                v-model="messageForm.title"
                outlined
                dense
                hide-details="hide-details"
                validate-on-blur
                required
                :rules="[
                  (v) =>
                    !!v ||
                    (type == 'sms' ? 'Title' : 'Subject') + ' is required',
                ]"
              ></v-text-field>
            </v-col>
            <div class="ml-4" style="margin-top: -10px">
              <!-- <span class="overline">Placeholders</span> -->
              <!-- <v-tooltip top max-width="250">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon color="grey lighten-1">mdi-information</v-icon>
                  </v-btn>
                </template> -->
              <!-- <span class="text-center">
                Placeholder is used to add dynamic data in you message.
                Placerholder will be replaced with actual data representing each
                of them. Please click to copy and paste it on your message
              </span> -->
              <!-- </v-tooltip> -->
              <!-- <template v-for="item in placeholders">
                <v-chip
                  :key="item.id"
                  class="mr-2 pa-4"
                  @click="copyPlaceholder(item)"
                >
                  {{ item.name }}
                  <v-icon right small>mdi-content-copy</v-icon>
                </v-chip>
              </template> -->
            </div>
            <v-col cols="12" sm="12" md="12">
              <label>Message</label>
              <v-textarea
                v-if="type == 'announcement'"
                v-model="messageForm.message"
                outlined
                required
                :rules="[(v) => !!v || 'Message is required']"
                rows="3"
                dense
              ></v-textarea>
              <text-editor
                v-else
                @complete="setEmailContent"
                :message="emailEditContent"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <div class="titles mt-8 blue-text">Configuration</div>
      <v-card class="rounded-5 shadow-0">
        <v-card-text class="pb-0">
          <v-row>
            <!-- <v-col cols="12" sm="4" md="4">
              <v-select
                v-model="messageForm.message_type"
                outlined
                :menu-props="{ bottom: true, offsetY: true }"
                background-color="#fff"
                label="Schedule Type*"
                item-text="name"
                :readonly="messageForm.id != null"
                item-value="value"
                :items="[
                  { name: 'Scheduled', value: 's' },
                  { name: 'Automated', value: 'a' },
                ]"
                required
                :rules="[(v) => !!v || 'Type is required']"
              ></v-select>
            </v-col> -->
            <v-col cols="12" sm="4" md="4">
              <label for="">Type*</label>
              <v-select
                v-model="messageForm.marketing_type"
                outlined
                :menu-props="{ bottom: true, offsetY: true }"
                item-text="name"
                item-value="value"
                :items="[{ name: 'General Announcement', value: 'a' }]"
                required
                :rules="[(v) => !!v || 'Type is required']"
                class="q-autocomplete shadow-0"
                dense
                hide-details="hide-details"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <label for="">Scheduled Date*</label>
              <date-field
                v-model="messageForm.date"
                :rules="[(v) => !!v || 'Schedule date is required']"
                :hide-details="true"
                class="q-text-field shadow-0"
                dense
                outlined
              />
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <label for="">Hour*</label>
              <v-text-field
                v-model="messageForm.time"
                type="time"
                :min="minTime"
                outlined
                required
                :rules="[(v) => !!v || 'Schedule time is required']"
                class="q-text-field shadow-0"
                dense
                hide-details="hide-details"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-row class="mt-3">
        <v-spacer></v-spacer>
        <v-btn @click="gotoMail" class="ma-2 white--text blue-color" text
          >Close</v-btn
        >
        <v-btn
          color="darken-1"
          class="ma-2 white--text teal-color"
          text
          @click="saveMarketingMessage"
          >Save</v-btn
        >
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      messageForm: {
        message_type: "s",
      },
      menu: false,
      currentPage: 0,
      pageSize: 10,
      items: [],
      names: [],
      name: null,
      customer_type_id: null,
      country: null,
      customerTypes: [],
      phones: [],
      phone: null,
      emails: [],
      email: null,
      isLoading: false,
      searchDatas: [],
      searchFlag: false,
      AgeRange: ["All", "18-25", "26-30", "31-35"],
      Age: [],
      toAge: null,
      fromAge: null,
      page: 1,
      perPage: null,
      totalPages: 1,
      userModel: { userID: null, type: "details" },
      selected: [],
      currentPageIds: [],
      valid: false,
      rules: [],
      placeholders: [],
      type: "announcement",
      emailEditContent: "",
      currentDay: moment().format("YYYY-MM-DD"),
    };
  },
  components: {},
  mounted() {
    if (typeof this.$route.params.type != "undefined") {
      this.type = this.$route.params.type;
      this.messageForm.type = this.type;
    }
    if (typeof this.$route.params.id != "undefined") {
      this.messageForm.id = this.$route.params.id;
      this.getMessageDetails();
    }
  },
  watch: {},
  computed: {
    ...mapGetters({
      checkReadPermission: "checkReadPermission",
    }),
    minTime() {
      let marker = "00:00";
      if (
        this.messageForm.date == null ||
        moment(this.messageForm.date, "YYYY-MM-DD").isSame()
      ) {
        marker = moment().format("HH:mm");
      }
      return marker;
    },
    getFormatDate() {
      if (this.messageForm.date) {
        return moment(String(this.messageForm.date)).format("Do MMM YYYY");
      }
      return null;
    },
    countries() {
      return this.$store.getters.getCountries.data;
    },
    memberships() {
      return this.$store.getters.getMemberships.data;
    },
    venueServices() {
      return this.$store.getters.getVenueServices.data;
    },
    productTypes() {
      return this.$store.getters.getProductTypes.data;
    },
  },
  methods: {
    toggle(type, field) {
      this.$nextTick(() => {
        if (this.messageForm[field].length == this[type].length) {
          this.messageForm[field] = [];
        } else {
          if (type == "memberships") {
            this.messageForm[field] = this[type].map((x) => x.membership_id);
          } else {
            this.messageForm[field] = this[type].map((x) => x.id);
          }
        }
      });
      this.$forceUpdate();
    },
    getIcon(type, field) {
      let icon = "mdi-checkbox-blank-outline";

      if (this.messageForm[field].length == this[type].length) {
        icon = "mdi-close-box";
      }
      if (
        this.messageForm[field].length > 0 &&
        this.messageForm[field].length != this[type].length
      )
        icon = "mdi-minus-box";

      return icon;
    },

    copyPlaceholder(data) {
      const el = document.createElement("textarea");
      el.value = data.placeholder;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      const selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false;
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.showInfo(
        "Placeholder for " + data.name + " copied to clipboard",
        2000
      );
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
    },
    showUserModel(userId) {
      this.userModel.userID = parseInt(userId);
      this.userModel.type = "details";
    },

    customerSelection() {
      let data = this.currentPageIds.filter((i) => !this.selected.includes(i));
      if (typeof this.messageForm.excluded_customer_ids == "undefined") {
        this.messageForm.excluded_customer_ids = [];
      }
      this.messageForm.excluded_customer_ids.push(...data);
      this.messageForm.excluded_customer_ids =
        this.messageForm.excluded_customer_ids.filter(
          (id) => !this.selected.includes(id)
        );
      this.messageForm.excluded_customer_ids = [
        ...new Set(this.messageForm.excluded_customer_ids),
      ];
    },
    saveMarketingMessage() {
      if (!this.$refs.form.validate()) {
        this.showError("Please fill all required fields");
        return;
      }
      this.showLoader();
      if (this.messageForm.message_type == "s") {
        this.messageForm.schedule_date = moment(
          this.messageForm.date + " " + this.messageForm.time,
          "YYYY-MM-DD HH:mm"
        ).format("YYYY-MM-DD HH:mm:ss");
        delete this.messageForm.rule_id;
      } else {
        this.messageForm.schedule_date = moment().format("YYYY-MM-DD HH:mm:ss");
      }
      var config = {
        method: "post",
        url:
          "marketing" +
          (this.messageForm.id != null ? "/" + this.messageForm.id : ""),
        data: this.messageForm,
      };
      this.$http(config)
        .then((response) => {
          if (response.status == 200 && response.data.status == true) {
            this.hideLoader();
            this.showSuccess("Added successfully");
            this.$router.push({
              name: "AnnouncementDetails",
              params: { type: this.type },
            });
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    getMessageDetails() {
      this.showLoader("Loading");
      this.$http
        .get("marketing/" + this.messageForm.id)
        .then((response) => {
          if (response.status == 200 && response.data.status == true) {
            const data = response.data.data;
            this.messageForm.title = data.title;
            this.messageForm.message = data.message;
            if (this.type == "email") {
              this.emailEditContent = data.message;
            }
            this.messageForm.message_type = data.message_type;
            this.messageForm.marketing_type = data.marketing_type;
            this.$set(
              this.messageForm,
              "date",
              moment(data.schedule_date, "YYYY-MM-DD HH:mm:ss").format(
                "YYYY-MM-DD"
              )
            );
            this.$set(
              this.messageForm,
              "time",
              moment(data.schedule_date, "YYYY-MM-DD HH:mm:ss").format("HH:mm")
            );
            this.hideLoader();
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },

    setEmailContent(content) {
      this.messageForm.message = content;
    },
    gotoMail() {
      this.$router.push({
        name: "AnnouncementDetails",
        params: { type: this.type },
      });
    },
  },
};
</script>





